import React from 'react';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './Banner.module.scss';

const Banner = ({ tag, children }) => (
  <div data-bem="Banner" data-tag={fromAnyToTrimmed(tag)} className={CN.component}>
    {children}
  </div>
);
export default Banner;
